@if (isExpanded) {
  <div class="container">
    <mat-icon aria-hidden="false" [attr.aria-label]="'disclosureIndicator.collapseItem' | transloco" [style.color]="this.color ? this.color : null">expand_less</mat-icon>
  </div>
} @else {
  <mat-icon aria-hidden="false" [attr.aria-label]="'disclosureIndicator.expandItem' | transloco" [style.color]="this.color ? this.color : null">expand_more</mat-icon>
}

